module.exports = __webpack_public_path__ + "img/skor-step-2.f7ba9252.png";